import React from 'react';
import { MapPin, ArrowRight } from 'lucide-react';

interface LocationQuestionProps {
  onLocationSelect: (isMarblehead: boolean) => void;
}

export default function LocationQuestion({ onLocationSelect }: LocationQuestionProps) {
  return (
    <div className="text-center space-y-8">
      <div className="relative">
        <MapPin className="w-20 h-20 text-[#fda36b] mx-auto mb-6 animate-float" />
        <div className="absolute inset-0 bg-[#fda36b]/20 blur-xl rounded-full" />
      </div>

      <div className="space-y-4">
        <h2 className="text-4xl font-bold text-white">
          Where do you call home?
        </h2>
        <p className="text-xl text-white/80 leading-relaxed max-w-lg mx-auto">
          We're starting hyperlocal in Marblehead, MA. If you're one of our neighbors, 
          you get access to our special community pricing and personal delivery!
        </p>
      </div>

      <div className="flex flex-col gap-4 max-w-md mx-auto">
        <button
          onClick={() => onLocationSelect(true)}
          className="group bg-gradient-to-r from-[#fda36b] to-[#fda36b]/80 text-[#132947] px-8 py-4 rounded-lg font-semibold text-lg hover:from-[#fda36b]/90 hover:to-[#fda36b]/70 transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-3"
        >
          🏠 Marblehead, MA (That's me!)
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </button>
        
        <button
          onClick={() => onLocationSelect(false)}
          className="group bg-white/10 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/20 transition-all duration-300 border border-white/20 hover:border-[#fda36b]/30 flex items-center justify-center gap-3"
        >
          🌍 Somewhere else (for now...)
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </button>
      </div>

      <div className="bg-white/5 p-6 rounded-lg border border-white/10 max-w-lg mx-auto">
        <p className="text-white/80 text-sm leading-relaxed">
          <span className="font-semibold text-[#fda36b]">Not in Marblehead yet?</span> Don't worry! 
          We're planning to expand to neighboring towns soon. You\'ll still get amazing coffee, 
          just with standard shipping for now.
        </p>
      </div>
    </div>
  );
}